/**
 * tính chất nguồn
 */
export default {
  NotSelected: 0,
  Regular: 1,
  IRegular: 2,
};
